import Image from '@base/Image';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import React, { useEffect, useRef } from 'react';
import NotesDetails from './NotesDetails';

const HeaderWrapper = styled.div`
  min-height: ${Spacings.SPACING_17B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    flex-direction: column-reverse;
    justify-content: space-between;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 286px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: calc(100vh / 4);
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;

const formatDuration = (duration) => {
  if (duration >= 30) {
    const months = Math.floor(duration / 30);
    return months === 1 ? `${months} month` : `${months} months`;
  }
  return `${duration} day${duration === 1 ? '' : 's'}`;
}; // TODO: move to utils

const Header = ({
  data,
  setIsStickyHeaderShown,
  setAccessDuration,
  cbtInfo,
  onOpenCbtVenueSelection
}) => {
  const headerRef = useRef();
  const { landscapeThumbnail, skuDetails } = data;

  setAccessDuration(formatDuration(skuDetails?.duration));

  useEffect(() => {
    const headerElement = headerRef.current;
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsStickyHeaderShown(false);
        }
        if (!entries[0].intersectionRatio) {
          setIsStickyHeaderShown(true);
        }
      },
      { threshold: 0, rootMargin: '-72px' }
    );
    intersectionObserver.observe(headerElement);
    return () => intersectionObserver.unobserve(headerElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HeaderWrapper ref={headerRef}>
      <Container>
        <NotesDetails
          isSticky={false}
          isHeaderShown
          data={data}
          cbtInfo={cbtInfo}
          onOpenCbtVenueSelection={onOpenCbtVenueSelection}
        />
        <ImageWrapper>
          <Image src={landscapeThumbnail} alt="" layout="fill" priority />
        </ImageWrapper>
      </Container>
    </HeaderWrapper>
  );
};
export default React.memo(Header);
